import { memo } from "react";
import { FormattedMessage } from "react-intl";
import "./FullyCustomizableNote.scss";
import { ICON_SIZES } from "app/constants";
import IdeaFilledIcon from "app/icons/profile/IdeaFilledIcon";

const FullyCustomizableNote = () => {
	return (
		<div className="fully-customizable-note">
			<IdeaFilledIcon size={ICON_SIZES.XS} />
			<FormattedMessage id="product.page.negociated.note" />
		</div>
	);
};

export default memo(FullyCustomizableNote);
